<template>
  <div class="vendor_cash_purchase-main glass-tab-page">
    <div class="vendor_cash_purchase-header-bar">
      <BrucdcumHeader
        :breadcrumb="['Vendor', 'New Cash Purchase']"
        :back-fallback="vendorsDashboardPath"
      />
    </div>
    <form class="vendor_cash_purchase-form" @submit.prevent>
      <div class="glass-tab-view glass-tab-view--flush vendor_cash_purchase-glass-shell">
        <div class="glass-tab-view__tabs">
          <TabNavigation
            v-model="activeTab"
            :tabs="tabs"
            @update:modelValue="handleTabChange"
          />
        </div>

        <div class="glass-tab-view__content vendor_cash_purchase-tab-content">
          <div v-if="activeTab === 'basic'" class="glass-tab-view__panel vendor_cash_purchase-tab-panel">
            <div class="glass-tab-panel glass-tab-panel--flex-column glass-tab-panel--stagger-rows vendor_cash_purchase-section">
              <div class="vendor_cash_purchase-invoice-meta-row">
                <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-input vendor_cash_purchase-meta-field">
                  <LabelInputField
                    input-id="cash-purchase-no"
                    label="No"
                    v-model="number"
                    placeholder="No"
                    flex
                  />
                </div>
                <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-date vendor_cash_purchase-meta-field">
                  <LabelDateField
                    input-id="cash-purchase-date"
                    label="Date"
                    v-model="dateUI"
                    flex
                    @change="onDateChange"
                  />
                </div>
              </div>

              <div class="vendor_cash_purchase-form-row vendor_cash_purchase-form-row--columns glass-tab-panel__row">
                <div class="vendor_cash_purchase-form-col">
                  <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-dropdown vendor_cash_purchase-required">
                    <LabelDropdown
                      label="Vendor Name"
                      select-id="cash-purchase-vendor"
                      v-model="vendorId"
                      flex
                      wide
                      required
                      searchable
                      :options="vendorDropdownOptions"
                      :has-error="!!validationErrors.vendorId"
                      @change="clearFieldError('vendorId')"
                    >
                      <div v-if="validationErrors.vendorId" class="vendor_cash_purchase-error-text">{{ validationErrors.vendorId }}</div>
                    </LabelDropdown>
                  </div>
                  <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-dropdown">
                    <LabelDropdown
                      label="Contact Name"
                      select-id="cash-purchase-contact"
                      v-model="contactName"
                      flex
                      wide
                      searchable
                      :options="contactDropdownOptions"
                    />
                  </div>
                  <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-input">
                    <LabelInputField
                      input-id="cash-purchase-phone"
                      label="Phone"
                      v-model="phone"
                      placeholder="Phone"
                      flex
                    />
                  </div>
                  <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-description">
                    <LabelDescriptionField
                      input-id="cash-purchase-bill-to"
                      label="Bill To"
                      v-model="billTo"
                      placeholder="Bill To"
                      :rows="4"
                      flex
                      @input="autoResizeBillTo"
                      @update:modelValue="autoResizeBillTo"
                    />
                  </div>
                </div>

                <div class="vendor_cash_purchase-form-col">
                  <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-dropdown vendor_cash_purchase-required">
                    <LabelDropdown
                      label="Payment Method"
                      select-id="cash-purchase-payment-method"
                      v-model="paymentMethod"
                      flex
                      wide
                      required
                      :options="paymentMethodDropdownOptions"
                    />
                  </div>
                  <template v-if="paymentMethod === 'Cheque'">
                    <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-checkbox">
                      <LabelCheckboxField
                        input-id="cash-purchase-to-be-printed"
                        label="TO BE PRINTED"
                        v-model="toBePrinted"
                        flex
                      />
                    </div>
                    <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-input">
                      <LabelInputField
                        input-id="cash-purchase-cheque-no"
                        label="Cheque No"
                        v-model="chequeNo"
                        :placeholder="toBePrinted ? 'TO BE PRINTED' : ''"
                        flex
                        :readonly="toBePrinted"
                      />
                    </div>
                  </template>
                  <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-dropdown vendor_cash_purchase-required">
                    <LabelDropdown
                      label="Pay From"
                      select-id="cash-purchase-pay-from"
                      v-model="payFrom"
                      flex
                      wide
                      required
                      searchable
                      :options="payFromDropdownOptions"
                      :has-error="!!validationErrors.payFrom"
                      @change="clearFieldError('payFrom')"
                    >
                      <div v-if="validationErrors.payFrom" class="vendor_cash_purchase-error-text">{{ validationErrors.payFrom }}</div>
                      <div v-if="payFromBalanceError" class="vendor_cash_purchase-error-text">{{ payFromBalanceError }}</div>
                    </LabelDropdown>
                  </div>
                  <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-date">
                    <LabelDateField
                      input-id="cash-purchase-delivery-date"
                      label="Delivery Date"
                      v-model="deliveryDateUI"
                      flex
                      @change="onDeliveryDateChange"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="activeTab === 'lines'" class="glass-tab-view__panel vendor_cash_purchase-tab-panel">
            <div class="glass-tab-panel glass-tab-panel--flex-column glass-tab-panel--stagger-rows vendor_cash_purchase-section">
              <div class="vendor_cash_purchase-itemize-section glass-tab-panel--nested">
                <div
                  class="vendor_cash_purchase-itemize-header glass-tab-panel__title"
                  @click="showAccountItems = !showAccountItems"
                >
                  <span v-if="showAccountItems">&#9660;</span><span v-else>&#9654;</span>
                  Itemize by Account
                </div>
                <template v-if="showAccountItems">
                  <div class="consultant-glass-table-section vendor_cash_purchase-table-section">
                    <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
                      <div class="consultant-glass-table-scroll-x">
                        <table class="consultant-glass-table vendor_cash_purchase-account-table vendor_cash_purchase-itemize-table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Description</th>
                              <th>Amount(USD)</th>
                              <th>Total</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, idx) in accountRows" :key="'account-' + idx" class="consultant-glass-table-row">
                              <td>
                                <select v-model="row.accountId" class="vendor_cash_purchase-form-control" @change="handleAccountDropdownChange(row)">
                                  <option value="">Select</option>
                                  <option v-for="account in accountList" :key="account.id" :value="Number(account.id)">
                                    {{ account.accountNumber ? account.accountNumber + ' - ' : '' }}{{ account.accountName }}{{ account.accountType ? ' - ' + account.accountType : '' }}
                                  </option>
                                  <option value="__new_account__">Add New Account</option>
                                </select>
                              </td>
                              <td><input v-model="row.description" type="text" /></td>
                              <td><input v-model="row.amount" type="number" min="0" step="any" /></td>
                              <td>{{ row.amount !== '' && row.amount != null ? Number(row.amount).toFixed(2) : '' }}</td>
                              <td class="vendor_cash_purchase-table-actions">
                                <SecondaryButton
                                  label="Delete"
                                  icon="bi bi-trash"
                                  custom-class="consultant-secondary-btn--danger"
                                  @click="removeAccountRow(idx)"
                                />
                              </td>
                            </tr>
                            <tr class="vendor_cash_purchase-table-total-row">
                              <td colspan="5">
                                Total (USD): <span class="vendor_cash_purchase-total-value">$ {{ accountTotal.toFixed(2) }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="vendor_cash_purchase-itemize-add-wrap">
                    <PrimaryButton label="Add New Account" icon="bi bi-plus-lg" @click="addAccountRow" />
                  </div>
                </template>
              </div>

              <div class="vendor_cash_purchase-itemize-section glass-tab-panel--nested">
                <div
                  class="vendor_cash_purchase-itemize-header glass-tab-panel__title"
                  @click="showProductItems = !showProductItems"
                >
                  <span v-if="showProductItems">&#9660;</span><span v-else>&#9654;</span>
                  Itemize by Product/Service
                </div>
                <template v-if="showProductItems">
                  <div class="consultant-glass-table-section vendor_cash_purchase-table-section">
                    <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
                      <div class="consultant-glass-table-scroll-x">
                        <table class="consultant-glass-table vendor_cash_purchase-product-table vendor_cash_purchase-itemize-table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Description</th>
                              <th>Quantity</th>
                              <th>Unit Price</th>
                              <th>Total</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, idx) in productRows" :key="'product-' + idx" class="consultant-glass-table-row">
                              <td>
                                <select v-model="row.selectedItem" class="vendor_cash_purchase-form-control" @change="onProductServiceChange(row)">
                                  <option value="">Select</option>
                                  <option
                                    v-for="item in availableProductServiceItems(idx)"
                                    :key="item.type + '-' + item.id"
                                    :value="JSON.stringify({ id: item.id, type: item.type })"
                                  >
                                    {{ item.name }} - {{ item.type }}
                                  </option>
                                </select>
                              </td>
                              <td><input v-model="row.description" type="text" /></td>
                              <td><input v-model="row.quantity" type="number" min="0" step="any" /></td>
                              <td><input v-model="row.unitPrice" type="number" min="0" step="any" /></td>
                              <td>{{ row.quantity && row.unitPrice ? (Number(row.quantity) * Number(row.unitPrice)).toFixed(2) : '' }}</td>
                              <td class="vendor_cash_purchase-table-actions">
                                <SecondaryButton
                                  label="Delete"
                                  icon="bi bi-trash"
                                  custom-class="consultant-secondary-btn--danger"
                                  @click="removeProductRow(idx)"
                                />
                              </td>
                            </tr>
                            <tr class="vendor_cash_purchase-table-total-row">
                              <td colspan="6">
                                Total (USD): <span class="vendor_cash_purchase-total-value">$ {{ productServiceTotal.toFixed(2) }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="vendor_cash_purchase-itemize-add-wrap">
                    <PrimaryButton label="Add New Item" icon="bi bi-plus-lg" @click="addProductRow" />
                  </div>
                </template>
              </div>

              <div class="vendor_cash_purchase-form-group vendor_cash_purchase-form-group--label-description">
                <LabelDescriptionField
                  input-id="cash-purchase-comments"
                  label="Write comments for this New Cash Purchase."
                  v-model="comments"
                  placeholder="Comments"
                  flex
                />
              </div>

              <div class="vendor_cash_purchase-total-section glass-tab-panel--nested">
                <span>Total (USD)</span>
                <span class="vendor_cash_purchase-total-value">$ {{ finalTotal.toFixed(2) }}</span>
              </div>

              <div class="vendor_cash_purchase-secondary-actions">
                <SecondaryButton label="Make it recurring" icon="bi bi-arrow-repeat" @click="makeRecurring" />
                <SecondaryButton label="Save as draft" icon="bi bi-file-earmark" @click="saveAsDraft" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vendor_cash_purchase-form-actions glass-tab-view__actions">
        <template v-if="activeTab === 'lines'">
          <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="cancel" />
          <PrimaryButton label="Save and New" icon="bi bi-plus-lg" @click="saveAndNew" />
          <PrimaryButton label="Save and Close" icon="bi bi-check-lg" @click="saveAndClose" />
        </template>
        <template v-else>
          <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="cancel" />
          <PrimaryButton label="Next" icon="bi bi-arrow-right" @click="handleNext" />
        </template>
      </div>
    </form>

    <ErrorModal :show="showErrorModal" title="Error" :message="errorMessage" @close="closeErrorModal" />
  </div>
</template>

<script>
import '../styles/VendorCashPurchase.css';
import BrucdcumHeader from '@/components/BrucdcumHeader.vue';
import TabNavigation from '@/components/TabNavigation.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import ApiService from '@/services/api.service.js';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import LabelDropdown from '@/modules/consultant/components/LabelDropdown.vue';
import LabelDescriptionField from '@/modules/consultant/components/LabelDescriptionField.vue';
import LabelDateField from '@/modules/consultant/components/LabelDateField.vue';
import LabelCheckboxField from '@/modules/consultant/components/LabelCheckboxField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'VendorCashPurchase',
  components: {
    BrucdcumHeader,
    TabNavigation,
    ErrorModal,
    LabelInputField,
    LabelDropdown,
    LabelDescriptionField,
    LabelDateField,
    LabelCheckboxField,
    PrimaryButton,
    SecondaryButton,
  },
  data() {
    const today = new Date().toISOString().split('T')[0];
    return {
      tabs: [
        { id: 'basic', name: 'Basic Information' },
        { id: 'lines', name: 'Lines & Totals' },
      ],
      activeTab: 'basic',
      validationErrors: {},
      showErrorModal: false,
      errorMessage: '',
      vendorId: '',
      contactName: '',
      phone: '',
      billTo: '',
      date: today,
      number: '',
      paymentMethod: 'Cash',
      toBePrinted: true,
      chequeNo: 'TO BE PRINTED',
      payFrom: '',
      deliveryDate: today,
      comments: '',
      showAccountItems: true,
      showProductItems: true,
      accountRows: [{ accountId: '', description: '', amount: 0 }],
      productRows: [{ itemId: '', itemType: '', selectedItem: '', description: '', quantity: 0, unitPrice: 0 }],
      vendorList: [],
      contactList: [],
      payFromList: [],
      accountList: [],
      productList: [],
      serviceList: [],
      payFromBalanceError: '',
    };
  },
  computed: {
    companyId() {
      return this.$route.params.id;
    },
    vendorsDashboardPath() {
      return `/company/${this.companyId}/dashboard/vendors`;
    },
    dateUI: {
      get() {
        return this.formatDateForUI(this.date);
      },
      set(val) {
        this.onDateChange(val);
      },
    },
    deliveryDateUI: {
      get() {
        return this.formatDateForUI(this.deliveryDate);
      },
      set(val) {
        this.onDeliveryDateChange(val);
      },
    },
    productServiceList() {
      return [...this.productList, ...this.serviceList];
    },
    accountTotal() {
      return this.accountRows.reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    },
    productServiceTotal() {
      return this.productRows.reduce(
        (sum, row) => sum + (Number(row.quantity) || 0) * (Number(row.unitPrice) || 0),
        0,
      );
    },
    finalTotal() {
      return this.accountTotal + this.productServiceTotal;
    },
    vendorDropdownOptions() {
      return [
        { value: '', label: 'Select' },
        ...(this.vendorList || []).map((vendor) => ({
          value: String(vendor.id),
          label: vendor.vendorName,
        })),
      ];
    },
    contactDropdownOptions() {
      return [
        { value: '', label: 'Select' },
        ...(this.contactList || []).map((contact) => ({
          value: contact.name,
          label: `${contact.name}${contact.email ? ` (${contact.email})` : ''}${contact.primary ? ' [Primary]' : ''}`,
        })),
      ];
    },
    paymentMethodDropdownOptions() {
      const methods = [
        'Cash',
        'Cheque',
        'Credit Card',
        'Direct Deposit',
        'Master card',
        'Online Banking',
        'Standing Order',
        'Switch/Maestro',
        'Paypal',
      ];
      return methods.map((method) => ({ value: method, label: method }));
    },
    payFromDropdownOptions() {
      return [
        { value: '', label: 'Select' },
        ...(this.payFromList || []).map((acc) => ({
          value: String(acc.id),
          label: `${acc.accountNumber ? acc.accountNumber + ' - ' : ''}${acc.accountName}${acc.accountType ? ' - ' + acc.accountType : ''}`,
        })),
      ];
    },
  },
  watch: {
    vendorId(val) {
      const selected = this.vendorList.find((v) => String(v.id) === String(val));
      if (selected) {
        const address = selected.address || '';
        const details = selected.addressDetails || '';
        if (address && details) {
          this.billTo = `${address}\n${details}`;
        } else if (address) {
          this.billTo = address;
        } else if (details) {
          this.billTo = details;
        } else {
          this.billTo = '';
        }
        this.contactList = selected.contacts || [];
        this.contactName = '';
        this.phone = '';
      } else {
        this.billTo = '';
        this.contactList = [];
        this.contactName = '';
        this.phone = '';
      }
      this.autoResizeBillTo();
    },
    billTo() {
      this.autoResizeBillTo();
    },
    contactName(val) {
      const selectedContact = this.contactList.find((c) => c.name === val);
      this.phone = selectedContact ? selectedContact.phone || '' : '';
    },
    payFrom() {
      this.validatePayFromBalance();
    },
    toBePrinted(val) {
      if (val) {
        this.chequeNo = 'TO BE PRINTED';
      } else if (this.chequeNo === 'TO BE PRINTED') {
        this.chequeNo = '';
      }
    },
    accountRows: {
      handler() {
        this.validatePayFromBalance();
      },
      deep: true,
    },
    productRows: {
      handler() {
        this.validatePayFromBalance();
      },
      deep: true,
    },
  },
  async created() {
    try {
      const data = await ApiService.getAllVendors();
      this.vendorList = Array.isArray(data) ? data : [];
    } catch (err) {
      this.vendorList = [];
    }
    try {
      const res = await ApiService.getCompanyAccounts(this.companyId);
      const allAccounts = res.data.accounts || res.data || [];
      this.payFromList = allAccounts.filter((a) =>
        ['Cash', 'Bank', 'Paypal', 'Credit Card', 'Other current Asset'].includes(a.accountType),
      );
      this.accountList = allAccounts.filter((a) =>
        ['Expense', 'Other Expense', 'Cost of Goods Sold', 'Inventory Asset'].includes(a.accountType),
      );
      const productRes = await ApiService.get(`/vendor/product-items/company/${this.companyId}`);
      this.productList = (productRes.data || []).map((item) => ({
        id: item.id,
        name: item.productName,
        type: item.type,
        salesPrice: item.salesPrice,
      }));
      const serviceRes = await ApiService.get(`/vendor/service-items/company/${this.companyId}`);
      this.serviceList = (serviceRes.data || []).map((item) => ({
        id: item.id,
        name: item.serviceName,
        type: item.type,
        salesPrice: item.salesPrice,
      }));
    } catch (e) {
      this.payFromList = [];
      this.accountList = [];
      this.productList = [];
      this.serviceList = [];
    }
  },
  methods: {
    formatDateForUI(isoDate) {
      if (!isoDate) return '';
      const parts = String(isoDate).split('-');
      if (parts.length !== 3) return isoDate;
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    },
    parseDateFromUI(value) {
      if (!value) return '';
      const parts = String(value).split('/');
      if (parts.length !== 3) return value;
      const [month, day, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    onDateChange(value) {
      this.date = this.parseDateFromUI(value);
    },
    onDeliveryDateChange(value) {
      this.deliveryDate = this.parseDateFromUI(value);
    },
    handleTabChange() {},
    clearFieldError(field) {
      if (this.validationErrors[field]) {
        const next = { ...this.validationErrors };
        delete next[field];
        this.validationErrors = next;
      }
    },
    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
    showValidationErrors(errors) {
      this.validationErrors = errors;
      const messages = Object.values(errors)
        .map((m) => `• ${m}`)
        .join('\n');
      this.errorMessage = `Please fix the following issues:\n\n${messages}`;
      this.showErrorModal = true;
    },
    validateCurrentTab(tabId = this.activeTab) {
      const errors = {};
      if (tabId === 'basic') {
        if (!this.vendorId) {
          errors.vendorId = 'Vendor is required.';
        }
        if (!this.payFrom) {
          errors.payFrom = 'Pay From account is required.';
        }
      }
      return errors;
    },
    validateAll() {
      const all = {
        ...this.validateCurrentTab('basic'),
        ...this.validateCurrentTab('lines'),
      };
      this.validationErrors = all;
      if (Object.keys(all).length > 0) {
        this.showValidationErrors(all);
        return false;
      }
      return true;
    },
    handleNext() {
      const err = this.validateCurrentTab('basic');
      if (Object.keys(err).length > 0) {
        this.validationErrors = { ...this.validationErrors, ...err };
        this.showValidationErrors(err);
        return;
      }
      this.validationErrors = {};
      this.activeTab = 'lines';
    },
    cancel() {
      this.$router.push(this.vendorsDashboardPath);
    },
    async saveAndClose() {
      if (!this.validateAll()) return;
      await this.validatePayFromBalance();
      if (this.payFromBalanceError) return;
      try {
        await this.savePurchase();
        if (this.$toast) this.$toast.success('Cash purchase created successfully!');
        this.$router.push(this.vendorsDashboardPath);
      } catch (err) {
        const msg = err.response?.data?.error || err.message || 'Failed to save';
        if (this.$toast) this.$toast.error(msg);
        else {
          this.errorMessage = msg;
          this.showErrorModal = true;
        }
      }
    },
    async saveAndNew() {
      if (!this.validateAll()) return;
      await this.validatePayFromBalance();
      if (this.payFromBalanceError) return;
      try {
        await this.savePurchase();
        if (this.$toast) this.$toast.success('Cash purchase created successfully!');
        this.resetForm();
      } catch (err) {
        const msg = err.response?.data?.error || err.message || 'Failed to save';
        if (this.$toast) this.$toast.error(msg);
        else {
          this.errorMessage = msg;
          this.showErrorModal = true;
        }
      }
    },
    addAccountRow() {
      this.accountRows.push({ accountId: '', description: '', amount: 0 });
    },
    removeAccountRow(idx) {
      this.accountRows.splice(idx, 1);
    },
    addProductRow() {
      this.productRows.push({ itemId: '', itemType: '', selectedItem: '', description: '', quantity: 0, unitPrice: 0 });
    },
    removeProductRow(idx) {
      this.productRows.splice(idx, 1);
    },
    autoResizeBillTo() {
      this.$nextTick(() => {
        const el = document.getElementById('cash-purchase-bill-to');
        if (el) {
          el.style.height = 'auto';
          el.style.height = `${el.scrollHeight}px`;
        }
      });
    },
    handleAccountDropdownChange(row) {
      if (row.accountId === '__new_account__') {
        row.accountId = '';
        this.$router.push(`/company/${this.companyId}/dashboard/new-account`);
      }
    },
    availableProductServiceItems(currentIdx) {
      const selectedIds = this.productRows
        .filter((row, idx) => idx !== currentIdx)
        .map((row) => `${row.itemId}-${row.itemType}`);
      return this.productServiceList.filter((item) => !selectedIds.includes(`${item.id}-${item.type}`));
    },
    onProductServiceChange(row) {
      if (typeof row.selectedItem === 'string') {
        try {
          const parsed = JSON.parse(row.selectedItem);
          row.itemId = parsed.id;
          row.itemType = parsed.type;
        } catch (e) {
          row.itemId = '';
          row.itemType = '';
        }
      }
      const item = this.productServiceList.find((i) => i.id === row.itemId && i.type === row.itemType);
      row.unitPrice = item ? Number(item.salesPrice) || 0 : 0;
    },
    async validatePayFromBalance() {
      this.payFromBalanceError = '';
      if (!this.payFrom) return;
      try {
        const res = await ApiService.get(`/company-account/${this.payFrom}`);
        const account = res.data.account || res.data;
        const total = this.accountTotal + this.productServiceTotal;
        if (account && Number(account.currentBalance) < total) {
          this.payFromBalanceError = 'Insufficient balance in the selected account.';
        }
      } catch (e) {
        this.payFromBalanceError = 'Unable to check account balance.';
      }
    },
    async savePurchase() {
      const payload = {
        vendorId: this.vendorId,
        contactName: this.contactName,
        phone: this.phone,
        billTo: this.billTo,
        date: this.date,
        number: this.number,
        paymentMethod: this.paymentMethod,
        payFrom: this.payFrom,
        deliveryDate: this.deliveryDate,
        comments: this.comments,
        accountRecords: this.accountRows
          .filter((row) => row.accountId && row.accountId !== '__new_account__')
          .map((row) => ({
            accountId: row.accountId,
            description: row.description,
            amount: row.amount,
          })),
        itemRecords: this.productRows
          .filter((row) => row.itemId && row.itemType)
          .map((row) => ({
            itemId: row.itemId,
            itemType: row.itemType,
            description: row.description,
            quantity: row.quantity,
            unitPrice: row.unitPrice,
          })),
      };
      if (this.paymentMethod === 'Cheque') {
        payload.toBePrinted = this.toBePrinted;
        payload.chequeNo = this.chequeNo;
      }
      await ApiService.post('/vendor/cash-purchase', payload);
    },
    resetForm() {
      const today = new Date().toISOString().split('T')[0];
      this.activeTab = 'basic';
      this.validationErrors = {};
      this.vendorId = '';
      this.contactName = '';
      this.phone = '';
      this.billTo = '';
      this.date = today;
      this.number = '';
      this.paymentMethod = 'Cash';
      this.toBePrinted = true;
      this.chequeNo = 'TO BE PRINTED';
      this.payFrom = '';
      this.deliveryDate = today;
      this.comments = '';
      this.payFromBalanceError = '';
      this.accountRows = [{ accountId: '', description: '', amount: 0 }];
      this.productRows = [{ itemId: '', itemType: '', selectedItem: '', description: '', quantity: 0, unitPrice: 0 }];
      this.contactList = [];
    },
    makeRecurring() {
      this.$toast && this.$toast.info('Recurring cash purchase is not implemented yet.');
    },
    saveAsDraft() {
      this.$toast && this.$toast.info('Save as draft is not implemented yet.');
    },
  },
};
</script>
